import React from 'react'

import { Portlet } from '_zari/core'

import * as Modals from './modals'
import * as Tables from './tables'

const ListaVentasPortlet = ({ tablaRef }) => {
  const [mostrarCambioEstadoModal, setMostrarCambioEstadoModal] = React.useState(false)

  const clickCambiarAEstadoEnviado = React.useCallback(() => {
    setMostrarCambioEstadoModal(true)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header
          title='Lista ventas con detracción'
          buttons={[{ name: 'Cambiar a estado enviado', onClick: clickCambiarAEstadoEnviado }]}
        />
        <Portlet.Body>
          <Tables.VentasTable tablaRef={tablaRef} />
        </Portlet.Body>
      </Portlet>
      {mostrarCambioEstadoModal && (
        <Modals.CambioEstadoModal
          show={mostrarCambioEstadoModal}
          handleClose={() => setMostrarCambioEstadoModal(false)}
          reloadTable={tablaRef.current.reload}
        />
      )}
    </>
  )
}

export default React.memo(ListaVentasPortlet)
